
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import {Options} from "../utils/decorators";
import Swiper from 'swiper';

@Options({
    template: false,
})

export default class ImageGallery extends Marionette.View<Backbone.Model>{
    constructor(options?:object) {
        super(options);

        const element = <any>this.$el.get(0);

        if (!element) {
            return;
        }

        const slidesContainerSelector = element.querySelector('.gallery-blog__content');

        const fixedBodyClass = element.dataset.galleryFixedBodyClass || 'gallery-blog-fixed-body';

        const fullscreenClass = element.dataset.galleryFullscreenClass || 'gallery-blog--fullscreen';

        const positionContainer = element.querySelector(
            element.dataset.galleryPositionContainerSelector || '.gallery-blog__position'
        );

        const prevButton = element.querySelector(
            element.dataset.galleryPrevButtonSelector || '.gallery-blog__button--previous'
        );

        const nextButton = element.querySelector(
            element.dataset.galleryNextButtonSelector || '.gallery-blog__button--next'
        );

        const fullscreenButton = element.querySelector(
            element.dataset.galleryFullscreenButtonSelector || '.gallery-blog__button--fullscreen'
        );

        const images = element.querySelectorAll(
            element.dataset.galleryImageSelector || '.gallery-blog-slide__image'
        );

        let swiper = new Swiper(slidesContainerSelector, {
            init: true,
            speed: 400,
            loop: false,
            slidesPerView: 1,
            direction: 'horizontal',
            watchOverflow: true,
            simulateTouch: true,
            autoplay: false,
            observer: true,
            observeParents: true,
            preventInteractionOnTransition: true,
            navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
            },
            pagination: {
                el: positionContainer,
                type: 'fraction',
            },
        });

        if (fullscreenButton) {
            fullscreenButton.addEventListener('click', () => {
                if (isGalleryFullscreen()) {
                    endFullscreen();
                } else {
                    startFullscreen();
                }
            }, false);
        }

        document.addEventListener('keyup', event => {
            if (event.defaultPrevented) {
                return;
            }

            if (isGalleryFullscreen() === false) {
                return;
            }

            switch (event.key || event.code) {
                case 'Escape':
                case 'Esc':
                    endFullscreen();
                    break;
                case 'ArrowLeft':
                case 'Left':
                    swiper.slidePrev();
                    break;
                case 'ArrowRight':
                case 'Right':
                    swiper.slideNext();
                    break;
                default:
                    return;
            }
        });

        function isGalleryFullscreen() {
            return element.classList.contains(fullscreenClass);
        }

        let documentScrollTop = 0;

        function startFullscreen() {
            switchImages();
            element.classList.add(fullscreenClass);
            documentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            document.body.classList.add(fixedBodyClass);
        }

        function endFullscreen() {
            switchImages();
            element.classList.remove(fullscreenClass);
            document.body.classList.remove(fixedBodyClass);
            document.documentElement.scrollTop = document.body.scrollTop = documentScrollTop;
        }

        function switchImages() {
            images.forEach(image => {
                const { fullscreenSrc } = image.dataset;

                if (!fullscreenSrc) {
                    return;
                }

                image.dataset.fullscreenSrc = image.src;
                image.src = fullscreenSrc;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./@modules/views/image-gallery.ts